import { AnyAction } from 'redux';
import { NotificationState } from '../types/state';

let counter = 10000;
let initialState: NotificationState = {
  message: '',
  type: '',
  id: counter,
};

const notificationReducer = (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case 'API_ERROR': {
      return { message: 'Unexpected Error', type: 'error' };
    }
    case 'SHOW_NOTIFICATIONS': {
      return {
        message: action.payload.message,
        type: action.payload.type,
        id: counter++,
      };
    }
    case 'LOGOUT': {
      return initialState;
    }
    default:
      return state;
  }
};
export default notificationReducer;
